import { render } from "./diapo-news.vue?vue&type=template&id=7afb06c4&scoped=true"
import script from "./diapo-news.vue?vue&type=script&lang=js"
export * from "./diapo-news.vue?vue&type=script&lang=js"

import "./diapo-news.vue?vue&type=style&index=0&id=7afb06c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afb06c4"]])

export default __exports__